import Config from '../Config'

//  Ngrx Utility Class for various functions like Date format, Phone number format etc.
class NgrxUtils {
  hash (str) {
    /*eslint-disable */
    let hash = 0,
      i,
      chr
    if (str.length === 0) return hash
    for (i = 0; i < str.length; i++) {
      chr = str.charCodeAt(i)
      hash = (hash << 5) - hash + chr
      hash |= 0 // Convert to 32bit integer
    }
    return '' + hash // Return a string to help out our later comparisons
    /* eslint-enable */
  };

  splitPhoneNumber (phNumber, separators) {
    let numbers = []
    let start = 0
    for (let number of separators) {
      let end = start + number
      numbers.push(phNumber.slice(start, end))
      start += number
    }
    return numbers.filter(String)
  }

  formatPhoneNumber (num) {
    if (!num || num.length === 0) {
      return Config.defaultPhoneNumber
    }
    let formattedPhone = num.toString()
    if (formattedPhone.length > 0) {
      const matched = formattedPhone.match(/\d\.?\d*/g)
      switch (matched.length) {
        case 4: {
          formattedPhone = `(${matched[0]}) ${matched[1]}-${matched[2]} ext. ${matched[3]}`
          break
        }
        case 3: {
          formattedPhone = `(${matched[0]}) ${matched[1]}-${matched[2]}`
          break
        }
        case 2: {
          formattedPhone = `${matched[0]}-${matched[1]}`
          break
        }
        case 1: {
          const phoneNumberLength = formattedPhone.length
          let matched = []
          switch (phoneNumberLength) {
            case 16: { // Number Format = xxx (xxx) xxx-xxxx ext xxx
              matched = this.splitPhoneNumber(formattedPhone, [3, 3, 3, 4, 3])
              formattedPhone = `(${matched[1]}) ${matched[2]}-${matched[3]} ext. ${matched[4]}`
              break
            }
            case 13: { // Number Format = xxx (xxx) xxx-xxxx or (xxx) xxx-xxxx ext xxx
              if (num.startsWith('00')) {
                matched = this.splitPhoneNumber(formattedPhone, [3, 3, 3, 4])
                formattedPhone = `(${matched[1]}) ${matched[2]}-${matched[3]}`
              } else {
                matched = this.splitPhoneNumber(formattedPhone, [3, 3, 4, 3])
                formattedPhone = `(${matched[0]}) ${matched[1]}-${matched[2]} ext ${matched[3]}`
              }
              break
            }
            case 10: { // Number Format = (xxx) xxx-xxxx
              matched = this.splitPhoneNumber(formattedPhone, [3, 3, 4])
              formattedPhone = `(${matched[0]}) ${matched[1]}-${matched[2]}`
              break
            }
            case 7: { // Number Format = xxx-xxxx
              matched = this.splitPhoneNumber(formattedPhone, [3, 4])
              formattedPhone = `${matched[0]}-${matched[1]}`
              break
            }
            default: {
              break
            }
          }
          break
        }
        default: {
          break
        }
      }
    }
    return formattedPhone
  }

  // To copy multi level object
  deepCopyObject (oldObj) {
    var newObj = oldObj
    if (oldObj && typeof oldObj === 'object') {
      newObj = Object.prototype.toString.call(oldObj) === '[object Array]' ? [] : {}
      for (var i in oldObj) {
        newObj[i] = this.deepCopyObject(oldObj[i])
      }
    }
    return newObj
  }

  // To remove not required keys from object
  removeKeys (arr, obj) {
    arr.forEach(function (key) {
      delete obj[key]
    })
    return obj
  }

  isEmpty (value) {
    return (
      value === undefined ||
      value === null ||
      (typeof value === 'object' && Object.keys(value).length === 0) ||
      value.length === 0
    )
  }
}

const NgrxUtil = new NgrxUtils()

export default NgrxUtil



// WEBPACK FOOTER //
// ./src/util/NgrxUtils.js